import { FormTypes } from 'types/enums/EFormTypes'
import desktopLoginBackground from '../assets/images/desktop_login_bg.jpg'
import desktopSignupBackground from '../assets/images/desktop_signup_bg.jpg'
import desktopPersonalAreaBackground from '../assets/images/desktop_personal_area_bg.jpg'

const formTypesBackground: Record<FormTypes, string> = {
  [FormTypes.LOGIN_FORM]: desktopLoginBackground,
  [FormTypes.FORGOT_PASSWORD]: desktopLoginBackground,
  [FormTypes.RESET_PASSWORD]: desktopLoginBackground,
  [FormTypes.RESET_PASSWORD_SUCCESS]: desktopLoginBackground,
  [FormTypes.SIGN_UP_FORM]: desktopSignupBackground,
  [FormTypes.WELCOME_PAGE]: desktopLoginBackground,
  [FormTypes.SUCCESS_PAGE]: desktopLoginBackground,
  [FormTypes.LAST]: desktopLoginBackground,
  [FormTypes.PERSONAL_AREA_PAGE]: desktopPersonalAreaBackground,
  [FormTypes.MARKETING_MESSAGE_PAGE]: desktopLoginBackground,
}

export const getBackgroundForForm = (formType: FormTypes): string => {
  return formTypesBackground[formType]
}
